module.exports = __webpack_public_path__ + "5f2ecf7357b28fffe68ef4b66380aedb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/category-headers/reporting.svg
// module id = 1931
// module chunks = 0